module.exports = __webpack_public_path__ + "static/media/phonenumber.4fbd58f1.jpg";